import React, { useState, useEffect, Fragment } from 'react'
import {connect} from "react-redux"
import {NavLink} from "react-router-dom";
import { storage } from '../../../dataAccessLayer/fbConfig';


import {addAdv, updateAdv, fetchAdv, deleteAdv} from '../../../store/adv-reducer';
import {  setCurrentImg} from "../../../store/advView-reducer";



// Importing components

import Preloader from "../preloader/preloader";
import Adv from './adv';



//импорт иконок и элементов стиля
import leftArrow from '../../../assets/slider-svg/left-arrow.svg'
import rightArrow from '../../../assets/slider-svg/right-arrow.svg'
import {FiList, FiTrash2, FiEdit2} from 'react-icons/fi';
import {Button} from "@material-ui/core";
import api from "../../../dataAccessLayer/firebase";
import {compose} from "redux";





const AdvContainer = props => {

    const [imgUrl, setImgUrl] = useState([]);
    const [photoIndexArray, setPhotoIndexArray] = useState([]);
    const [progressBar, setProgressBar] = useState(0);
    const [visiblePopup, setVisiblePopup] = useState({modalUsers: false, modalDetails: false, modalWarning: false, modalUpdate: false});
    const [userId, setUserId] = useState(null);
    const [item, setItem] = useState(null);
    const [advInfo, setAdvInfo] = useState([]);
    const [localPhone,setLocalPhone] =useState([])

    const {
        usId,
        isAuth,
        isLoading,
        advsList,
        addAdv,
        deleteAdv,
        updateAdv,
        fetchAdv,
        setCurrentImg,
        currentImg

    } = props;


    useEffect(() => {
        fetchAdv()
    }, [fetchAdv])



    // Отображение модальных окон
    const onVisiblePopup = name => setVisiblePopup(prevVisiblePopup => ({
        ...visiblePopup,
        [name]: !prevVisiblePopup[name]
    }));

    // Загрузка файлов в Firebase
    const onHandleChangeFile = async e => {

        if(e.target.files !==[]) {
            let aditionalArray =[];
            console.log(`Количество фоток ${e.target.files.length}`)
            for (let i = 0; i <e.target.files.length; i++) {
                const file = e.target.files[i]
                if (!file.type.match('image.*')) {
                    continue;
                }


                storage.ref(`/images/${file.name}`).put(file)
                    .on('state_changed',
                    async snapshot => {
                        await setProgressBar(Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100));
                        console.log('процент загрузки ' + progressBar)
                    },
                    error => {
                        console.log(error);
                    },
                    async() => {
                        let url = await storage.ref('images').child(file.name).getDownloadURL()
                        console.log(imgUrl)
                        console.log(url)
                        aditionalArray.push(url)
                        console.log(imgUrl.concat(url))
                        setCurrentImg(currentImg.concat(url))
                       setImgUrl(aditionalArray)
                        console.log(imgUrl)
                    })
                console.log(`Проходка цикла номер ${i}`)

            }
            console.log(aditionalArray)
            setImgUrl([aditionalArray])
            setCurrentImg([aditionalArray])
            console.log(currentImg)
            console.log(imgUrl)

        };
    };

    // Сбор инфы с input'ov
    const onHandleCreateUserForm = e => {
        setAdvInfo({...advInfo, [e.target.id]: e.target.value})
        console.log(e.target.id)
        console.log(e.target.value)
        console.log(advInfo)
    };

    // Удаление юзера
    const onDeleteUser = (bool, advId) => {
        if(bool) {
            deleteAdv(advId);
            onVisiblePopup("modalWarning");
        };
    };


    // Рендер юзеров
    const onGetUsersList = () => {
        return advsList.map((items,index) => {


            //параметры для отображения даты
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timezone: 'UTC',
                hour: 'numeric',
                minute: 'numeric'
            };

            if (localPhone[index] === undefined || localPhone[index] === null) {
                setLocalPhone([...localPhone, localPhone[index] = "Показать телефон"])
            }

            if (photoIndexArray[index] === undefined || photoIndexArray[index] === null) {
                setPhotoIndexArray([...photoIndexArray, photoIndexArray[index] = 0])

            }
            //функции для слайдера
            const NextPhoto = () => {
                if(photoIndexArray[index] < items.imgUrl.length) {
                    setPhotoIndexArray([photoIndexArray[index] = photoIndexArray[index] + 1])
                    console.log(items.imgUrl.length)
                    console.log(`следущее фото  в объявлении ${index}`)
                    console.log(photoIndexArray[index])
                }
            }
            const PrevPhoto = () => {
                if(photoIndexArray[index] > 0) {
                    setPhotoIndexArray([photoIndexArray[index] = photoIndexArray[index] - 1])
                    console.log(`предыдущее  в объявлении ${index}`)
                    console.log(photoIndexArray[index])
                }
            }
            return (
                <div key={items.index} className="users__card">
                        <div className="card__data">

                            <div className="sliderContainer">
                                <NavLink to={'/adv/' + items.id}>
                               {/* <div className="left__slider">
                                    <img onClick={PrevPhoto} className="leftArrow" src={leftArrow} alt={"leftArrow"}/>
                                </div>*/}
                                {items.imgUrl ? <img className="cardPhoto" src={items.imgUrl[photoIndexArray[index]]}
                                                     alt={"Adv_avatar"}/> : null}
                               {/* <div className="right__slider">
                                    <img onClick={NextPhoto} className="rightArrow" src={rightArrow} alt={"rightArrow"}/>
                                </div>*/}

                                </NavLink>
                            </div>


                            <div className="advInfo">
                                <div className="infoSection">
                                    <div className="infoSectionItem">
                                        <NavLink to={'/adv/' + items.id}>
                                            {`${items.rooms} комн. квартира ${items.square} м2 ${items.floor} этаж`}
                                        </NavLink>
                                        <div>{`${items.price} руб`}
                                            <div className="pricePerSquare">
                                                {isNaN(items.price / items.square) === false ? `${Math.round(items.price / items.square)} руб/м2` : null}
                                            </div>
                                        </div>
                                    </div>

                                    {(usId === items.userId)
                                        ?
                                        < div className="adv__settings">
                                        <span className="user__details" onClick={() => {
                                            setItem(items);
                                            onVisiblePopup("modalUpdate");
                                        }}>
                                        <FiEdit2/>
                                        </span>
                                            <span onClick={() => {
                                                onVisiblePopup("modalWarning");
                                                setUserId(items.id);
                                            }}><FiTrash2/>
                                        </span>
                                        </div>
                                        : null
                                    }

                                </div>
                                <br/>
                                <div className="infoSection">
                                    <h5>{items.address}</h5>
                                </div>
                                <br/>
                                <div className="advDescription">{
                                    items.description.length >= 185
                                        ? <div>
                                            {items.description.slice(0, 185)}

                                            < NavLink to={'/adv/' + items.id}>
                                                ...Подробней
                                            </NavLink>
                                        </div>
                                        : `${items.description}`
                                }</div>
                                <br/>
                                <div className="panel__container">
                                   {/* <Button
                                        type="submit"
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                            setLocalPhone([localPhone[index]=items.phone])
                                        }}
                                    >{localPhone[index]}
                                    </Button>*/}

                                    <h4>{`+7 ${items.phone}`}</h4>
                                    <div className="rightPanel">
                                        {`${items.date.toDate().toLocaleString("ru", options)}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            )
        })
    };

    return(!isLoading
            ? <Preloader/>
            : <Fragment>
                <Adv
                    usId={usId}
                    isAuth={isAuth}
                    onGetUsersList={onGetUsersList}
                    onVisiblePopup={onVisiblePopup}
                    onHandleChangeFile={onHandleChangeFile}
                    imgUrl={imgUrl}
                    setImgUrl={setImgUrl}
                    photoIndexArray={photoIndexArray}
                    setPhotoIndexArray={setPhotoIndexArray}
                    progressBar={progressBar}
                    setProgressBar={setProgressBar}
                    addAdv={addAdv}
                    onDeleteUser={onDeleteUser}
                    userId={userId}
                    item={item}
                    updateAdv={updateAdv}
                    onHandleCreateUserForm={onHandleCreateUserForm}
                    advInfo={advInfo}
                    visiblePopup={visiblePopup}
                />
            </Fragment>
    );
};

// Redux
const mapStateToProps = state => {
    return {
        isAuth: state.auth.isAuth,
        usId: state.auth.userId,
        advsList: state.adv.advsList,
        isLoading: state.adv.isLoading,
        currentImg: state.advView.currentImg

    };
};

const withConnect = connect(mapStateToProps, {fetchAdv, addAdv, deleteAdv, updateAdv, setCurrentImg})

export default compose(withConnect)(AdvContainer)







